import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <Container className="text-center my-5">
      <h1 className="display-4">404 - Page introuvable</h1>
      <p className="lead">
        Désolé, la page que vous cherchez n'existe pas.
      </p>
      <Link to="/" className="btn btn-primary mt-3">
        Retour à l'accueil
      </Link>
    </Container>
  );
};

export default NotFound;
